import * as React from 'react';
import classNames from 'classnames';

import { CloseButton } from './components/CloseButton';
import * as styles from './Sidebar.css';

interface ISidebarProps {
  children: React.ReactNode;
  opened: boolean;
  onClose?(): void;
}

export const Sidebar: React.FC<ISidebarProps> = ({ children, opened, onClose }) => {
  return (
    <div className={classNames(styles['container'], opened && styles['opened'])}>
      {children}
      <CloseButton onClick={onClose} />
    </div>
  );
};

Sidebar.displayName = 'Sidebar';
